<script>
import Layout from '@layouts/main.vue'
import baseMixin from '@/mixins/baseMixin'
import BookingPendingApprovalsContainer from '@/components/booking/pendingApprovals/booking-pending-approvals-container.vue'

export default {
  name: 'PendingApprovalView',
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [{ name: 'description', content: 'Pending Approval page.' }],
    }
  },
  components: { Layout, BookingPendingApprovalsContainer },
  mixins: [baseMixin],
}
</script>

<template>
  <Layout>
    <BasePageHeader :title="$t('booking.pendingApproval.pageTitle')" />
    <BookingPendingApprovalsContainer />
  </Layout>
</template>
